import { StateSchema } from 'app/providers/StoreProvider';
import { createSelector } from 'reselect';

export const getAlertState = (state: StateSchema) => state.alert;

export const getAlertData = createSelector(getAlertState, (state) => state.alerts ?? []);
